export default "__VITE_ASSET__5vfTqNuo__"